import React, { useState } from "react";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import ImageGridInstagram from "../components/ImageGridInstagram";
import ImageListViewInstagram from "../components/ImageListViewInstagram";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const photos = [
  {
    src: "/images/vj2.jpg",
    description: "U čemu problem?",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj3.jpg",
    description: "Ništa lično...♠️📷 #luckyshot",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj4.jpg",
    description: "Ne znam gde sam koliko mi je dobro 😎😂",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj5.jpg",
    description: "Sad sve prestaje da bude važno 😎🌻",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj6.jpg",
    description: "You'll see that life is still worth while, if you just smile 😉",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj7.jpg",
    description: "🇮🇹🤌",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj8.jpg",
    description: "😌👌è buono",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj9.jpg",
    description: "Ti amo, Firenze ☕",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj10.jpg",
    description: "Just breathe #mountainhike",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj11.jpg",
    description: "🏂",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj12.jpg",
    description: "Ne može biti bolje od ovoga 🤪",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj13.jpg",
    description: "#miamivice 🌆",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj14.jpg",
    description: "Nećemo da preterujemo...",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj15.jpg",
    description: "#nbgblocklife",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj16.jpg",
    description: "🏖️",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj17.jpg",
    description: "#eventhorizon",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj18.jpg",
    description: "Neke navike ne treba menjati...",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj19.jpg",
    description: "About last night",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj20.jpg",
    description: "#beergarden",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
];

export default function InstagramDesktopVJ({
  username = "mr.wolf",
  bio = "Life is supposed to be fun! content creator",
  avatarUrl = "/images/vj1.jpg",
  posts = 258,
  followers = "524",
  following = 300,
}) {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("grid");
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="instagram-page">
      <div className="instagram-right">
        <div className="tab-icon-face">
          <AccountCircleIcon
            className={`tab-icon active`}
            fontSize="large"
            style={{ fontSize: "60px" }}
            onClick={() => handleTabClick("grid")}
          />
        </div>
        <div className="tab-icon-instagram">
          <GridOnOutlinedIcon
            className={`tab-icon ${activeTab === "grid" ? "active" : ""}`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => handleTabClick("grid")}
          />
        </div>
        <div className="tab-icon-instagram">
          <ViewListOutlinedIcon
            className={`tab-icon ${activeTab === "list" ? "active" : ""}`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => handleTabClick("list")}
          />
        </div>
        <div className="tab-icon-instagram">
          <SearchOutlinedIcon
            className={`tab-icon ${activeTab === "search" ? "active" : ""}`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => handleTabClick("search")}
          />
        </div>
        <div className="tab-icon-instagram">
          <BookmarkBorderOutlinedIcon
            className={`tab-icon ${activeTab === "saved" ? "active" : ""}`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => handleTabClick("saved")}
          />
        </div>
      </div>
      <div className="instagram-left">
        <div className="instagram-left-header">
          <div className="search-bar">
            <SearchOutlinedIcon
              className={`nav-icon-instagram`}
              fontSize="large"
              style={{ fontSize: "35px" }}
            />
            <input
              type="text"
              value=""
              className="search-input"
              placeholder="Search..."
            />
          </div>
          <HomeOutlinedIcon
            className={`nav-icon-instagram active`}
            fontSize="large"
            style={{ fontSize: "45px" }}
          />
          <SmartDisplayOutlinedIcon
            className={`nav-icon-instagram`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => navigate("/notifikacije")}
          />
          <button className="add-photo-btn">
            <FaPlus className="add-photo-icon" />
            Add photo
          </button>
        </div>

        <div className="instagram-top">
          <div className="instagram-avatar-ring">
            <img
              className="instagram-avatar"
              src={avatarUrl}
              alt={`${username} avatar`}
            />
          </div>

          <div className="instagram-user">
            <div className="instagram-row">
              <div className="instagram-username">{username}</div>
            </div>
            <div className="instagram-bio">{bio}</div>
          </div>
        </div>
        <div className="instagram-actions">
          <button className="instagram-btn-following">Following</button>
          <button className="instagram-btn-message">Message</button>
          <button className="instagram-btn-icon" aria-label="Add">
            <span className="instagram-plus">＋</span>
          </button>
        </div>
        <div className="instagram-stats">
          <div className="instagram-stat">
            <div className="instagram-num">{posts}</div>
            <div className="instagram-label">posts</div>
          </div>
          <div className="instagram-stat">
            <div className="instagram-num">{followers}</div>
            <div className="instagram-label">followers</div>
          </div>
          <div className="instagram-stat">
            <div className="instagram-num">{following}</div>
            <div className="instagram-label">following</div>
          </div>
        </div>
        <div className="instagram-profile-tabs">
          <GridOnOutlinedIcon
            className={`instagram-tab-icon ${
              activeTab === "grid" ? "active" : ""
            }`}
            fontSize="large"
            onClick={() => handleTabClick("grid")}
          />

          <ViewListOutlinedIcon
            className={`instagram-tab-icon ${
              activeTab === "list" ? "active" : ""
            }`}
            fontSize="large"
            onClick={() => handleTabClick("list")}
          />

          <SearchOutlinedIcon
            className={`instagram-tab-icon ${
              activeTab === "search" ? "active" : ""
            }`}
            fontSize="large"
            onClick={() => handleTabClick("search")}
          />

          <BookmarkBorderOutlinedIcon
            className={`instagram-tab-icon ${
              activeTab === "saved" ? "active" : ""
            }`}
            fontSize="large"
            onClick={() => handleTabClick("saved")}
          />
        </div>
        {activeTab === "grid" ? (
          <ImageGridInstagram images={photos} />
        ) : (
          <ImageListViewInstagram images={photos} />
        )}
      </div>
    </div>
  );
}
